import { Box, Grid } from '@mui/material';
import { useState } from 'react';
import { IVendorLists } from 'wisestep-api';
import { ScrollableTabs, TabTextVariant } from 'wisestep-base';

import VendorListBanner from '../vendorListBanner/VendorListBanner';

import AddNewVendor from './AddNewVendor';
import UploadVendors from './UploadVendors';

interface AddVendorsProps {
  vendorList: IVendorLists;
}

const AddVendors = ({ vendorList }: AddVendorsProps) => {
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <Box>
      <Grid item xs={12}>
        <VendorListBanner vendorList={vendorList} />
        <ScrollableTabs
          variant={TabTextVariant.SUB_TITLE}
          scrollList={[{ tabName: 'Upload a File' }, { tabName: 'Add a Vendor' }]}
          getTabIndex={(index: number) => setTabIndex(index)}
        />
        {tabIndex === 0 && <UploadVendors vendorList={vendorList} />}
        {tabIndex === 1 && <AddNewVendor vendorList={vendorList} />}
      </Grid>
    </Box>
  );
};

export default AddVendors;
